var v1="<div class=\"content-wrap center\"><div class=\"title\">{{:: '_DASHBOARD.FAVORITE_COURSE' | translate }}&nbsp;<span class=\"small\"> {{:: '_DASHBOARD.RANKING' | translate }}</span></div><div ng-repeat=\"item in favoriteCourses\" class=\"row\"><div class=\"column-value\"><div class=\"value-round-rect\">{{ ::item.cnt_score_cards }}</div></div><div class=\"column-content\"><div class=\"date\">{{ ::item.play_date }}</div><div class=\"desc\">{{ ::item.club_name }} {{ ::item.course_name }}</div></div></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("dashboard/favorite-course/favorite-course.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/dashboard/favorite-course/favorite-course.jade
// module id = 552
// module chunks = 0